import axios from 'axios';

export const FETCH_PEER_CONFIG_REQUEST = 'FETCH_PEER_CONFIG_REQUEST';
export const FETCH_PEER_CONFIG_SUCCESS = 'FETCH_PEER_CONFIG_SUCCESS';
export const FETCH_PEER_CONFIG_FAILURE = 'FETCH_PEER_CONFIG_FAILURE';

export const UPDATE_PEER_CONFIG_REQUEST = 'UPDATE_PEER_CONFIG_REQUEST';
export const UPDATE_PEER_CONFIG_SUCCESS = 'UPDATE_PEER_CONFIG_SUCCESS';
export const UPDATE_PEER_CONFIG_FAILURE = 'UPDATE_PEER_CONFIG_FAILURE';

export const fetchPeerConfig = () => ({
    type: FETCH_PEER_CONFIG_REQUEST
});

export const updatePeerConfig = (config) => ({
    type: UPDATE_PEER_CONFIG_REQUEST,
    payload: config
});
